import "./Skeleton.css";

interface SkeletonProps {
  readonly width: number | string;
  readonly height: number | string;
  readonly className?: string;
}

/**
 * スケルトン。無地の面を実寸で置くだけで、シマー・明滅はしない（ui-design.md §5.9）。
 * **呼び出し側の責務**: 100ms以内に実体が描画できる見込みなら、そもそも描画しないこと
 * （先読みが速いケースでスケルトンだけが一瞬点滅するのを避けるため）。
 */
export function Skeleton({ width, height, className }: SkeletonProps) {
  return (
    <span
      className={["skeleton", className].filter(Boolean).join(" ")}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}
